/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  InventorySkuSelectionResponse,
  RemoteAccessErrorResponse,
  RemoteLaunchIntent,
  RemoteLaunchReplayResponse,
  RemoteSessionRead,
  RemoteTakeoverCreate,
  RemoteTakeoverEmpty,
  RemoteTakeoverRead,
  SellerRemoteHostListResponse,
  SellerRemoteMembersRead,
  SellerRemoteMembersWrite,
  SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams
} from '../model';

import { orvalClient } from '../../orval-client';




export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse200 = {
  data: InventorySkuSelectionResponse
  status: 200
}

export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse403 = {
  data: void
  status: 403
}

export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponseSuccess = (skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse200) & {
  headers: Headers;
};
export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponseError = (skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse403 | skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse422) & {
  headers: Headers;
};

export type skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse = (skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponseSuccess | skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponseError)

export const getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetUrl = (params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/inventory/skus/selection-ids?${stringifiedParams}` : `/api/v1/admin/inventory/skus/selection-ids`
}

/**
 * @summary Matching SKU identities, capped at 2000 (admin Ring 3).
 */
export const skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet = async (params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options?: RequestInit): Promise<skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse> => {

  return orvalClient<skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetResponse>(getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryKey = (params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams,) => {
    return [
    `/api/v1/admin/inventory/skus/selection-ids`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryOptions = <TData = Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError = void | HTTPValidationError>(params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>> = ({ signal }) => skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>>
export type SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryError = void | HTTPValidationError


export function useSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet<TData = Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError = void | HTTPValidationError>(
 params: undefined |  SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>,
          TError,
          Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet<TData = Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError = void | HTTPValidationError>(
 params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>,
          TError,
          Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet<TData = Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError = void | HTTPValidationError>(
 params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Matching SKU identities, capped at 2000 (admin Ring 3).
 */

export function useSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet<TData = Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError = void | HTTPValidationError>(
 params?: SkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuSelectionIdsEndpointApiV1AdminInventorySkusSelectionIdsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createAdminRemoteTakeoverResponse200 = {
  data: RemoteTakeoverRead
  status: 200
}

export type createAdminRemoteTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type createAdminRemoteTakeoverResponse403 = {
  data: RemoteAccessErrorResponse
  status: 403
}

export type createAdminRemoteTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type createAdminRemoteTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type createAdminRemoteTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type createAdminRemoteTakeoverResponse429 = {
  data: RemoteAccessErrorResponse
  status: 429
}

export type createAdminRemoteTakeoverResponseSuccess = (createAdminRemoteTakeoverResponse200) & {
  headers: Headers;
};
export type createAdminRemoteTakeoverResponseError = (createAdminRemoteTakeoverResponse401 | createAdminRemoteTakeoverResponse403 | createAdminRemoteTakeoverResponse404 | createAdminRemoteTakeoverResponse409 | createAdminRemoteTakeoverResponse422 | createAdminRemoteTakeoverResponse429) & {
  headers: Headers;
};

export type createAdminRemoteTakeoverResponse = (createAdminRemoteTakeoverResponseSuccess | createAdminRemoteTakeoverResponseError)

export const getCreateAdminRemoteTakeoverUrl = (hostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${hostId}/takeover-requests`
}

/**
 * @summary Create Admin Takeover
 */
export const createAdminRemoteTakeover = async (hostId: string,
    remoteTakeoverCreate: RemoteTakeoverCreate, options?: RequestInit): Promise<createAdminRemoteTakeoverResponse> => {

  return orvalClient<createAdminRemoteTakeoverResponse>(getCreateAdminRemoteTakeoverUrl(hostId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverCreate)
  }
);}




export const getCreateAdminRemoteTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteTakeover>>, TError,{hostId: string;data: RemoteTakeoverCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteTakeover>>, TError,{hostId: string;data: RemoteTakeoverCreate}, TContext> => {

const mutationKey = ['createAdminRemoteTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRemoteTakeover>>, {hostId: string;data: RemoteTakeoverCreate}> = (props) => {
          const {hostId,data} = props ?? {};

          return  createAdminRemoteTakeover(hostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRemoteTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRemoteTakeover>>>
    export type CreateAdminRemoteTakeoverMutationBody = RemoteTakeoverCreate
    export type CreateAdminRemoteTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Create Admin Takeover
 */
export const useCreateAdminRemoteTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteTakeover>>, TError,{hostId: string;data: RemoteTakeoverCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRemoteTakeover>>,
        TError,
        {hostId: string;data: RemoteTakeoverCreate},
        TContext
      > => {
      return useMutation(getCreateAdminRemoteTakeoverMutationOptions(options), queryClient);
    }
    export type getCurrentAdminRemoteTakeoverResponse200 = {
  data: RemoteTakeoverRead | null
  status: 200
}

export type getCurrentAdminRemoteTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type getCurrentAdminRemoteTakeoverResponse403 = {
  data: RemoteAccessErrorResponse
  status: 403
}

export type getCurrentAdminRemoteTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type getCurrentAdminRemoteTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type getCurrentAdminRemoteTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type getCurrentAdminRemoteTakeoverResponseSuccess = (getCurrentAdminRemoteTakeoverResponse200) & {
  headers: Headers;
};
export type getCurrentAdminRemoteTakeoverResponseError = (getCurrentAdminRemoteTakeoverResponse401 | getCurrentAdminRemoteTakeoverResponse403 | getCurrentAdminRemoteTakeoverResponse404 | getCurrentAdminRemoteTakeoverResponse409 | getCurrentAdminRemoteTakeoverResponse422) & {
  headers: Headers;
};

export type getCurrentAdminRemoteTakeoverResponse = (getCurrentAdminRemoteTakeoverResponseSuccess | getCurrentAdminRemoteTakeoverResponseError)

export const getGetCurrentAdminRemoteTakeoverUrl = () => {




  return `/api/v1/admin/remote-access/takeover-requests/current`
}

/**
 * @summary Get Current Admin Takeover
 */
export const getCurrentAdminRemoteTakeover = async ( options?: RequestInit): Promise<getCurrentAdminRemoteTakeoverResponse> => {

  return orvalClient<getCurrentAdminRemoteTakeoverResponse>(getGetCurrentAdminRemoteTakeoverUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentAdminRemoteTakeoverQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/takeover-requests/current`
    ] as const;
    }


export const getGetCurrentAdminRemoteTakeoverQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentAdminRemoteTakeoverQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>> = ({ signal }) => getCurrentAdminRemoteTakeover({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentAdminRemoteTakeoverQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>>
export type GetCurrentAdminRemoteTakeoverQueryError = RemoteAccessErrorResponse


export function useGetCurrentAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>,
          TError,
          Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current Admin Takeover
 */

export function useGetCurrentAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentAdminRemoteTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentAdminRemoteTakeoverQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminRemoteTakeoverResponse200 = {
  data: RemoteTakeoverRead
  status: 200
}

export type getAdminRemoteTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type getAdminRemoteTakeoverResponse403 = {
  data: RemoteAccessErrorResponse
  status: 403
}

export type getAdminRemoteTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type getAdminRemoteTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type getAdminRemoteTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type getAdminRemoteTakeoverResponseSuccess = (getAdminRemoteTakeoverResponse200) & {
  headers: Headers;
};
export type getAdminRemoteTakeoverResponseError = (getAdminRemoteTakeoverResponse401 | getAdminRemoteTakeoverResponse403 | getAdminRemoteTakeoverResponse404 | getAdminRemoteTakeoverResponse409 | getAdminRemoteTakeoverResponse422) & {
  headers: Headers;
};

export type getAdminRemoteTakeoverResponse = (getAdminRemoteTakeoverResponseSuccess | getAdminRemoteTakeoverResponseError)

export const getGetAdminRemoteTakeoverUrl = (requestId: string,) => {




  return `/api/v1/admin/remote-access/takeover-requests/${requestId}`
}

/**
 * @summary Get Admin Takeover
 */
export const getAdminRemoteTakeover = async (requestId: string, options?: RequestInit): Promise<getAdminRemoteTakeoverResponse> => {

  return orvalClient<getAdminRemoteTakeoverResponse>(getGetAdminRemoteTakeoverUrl(requestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRemoteTakeoverQueryKey = (requestId: string,) => {
    return [
    `/api/v1/admin/remote-access/takeover-requests/${requestId}`
    ] as const;
    }


export const getGetAdminRemoteTakeoverQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRemoteTakeoverQueryKey(requestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRemoteTakeover>>> = ({ signal }) => getAdminRemoteTakeover(requestId, { signal });





   return  { queryKey, queryFn, enabled: requestId !== null && requestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRemoteTakeoverQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRemoteTakeover>>>
export type GetAdminRemoteTakeoverQueryError = RemoteAccessErrorResponse


export function useGetAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
 requestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteTakeover>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteTakeover>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Takeover
 */

export function useGetAdminRemoteTakeover<TData = Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError = RemoteAccessErrorResponse>(
 requestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRemoteTakeoverQueryOptions(requestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type cancelAdminRemoteTakeoverResponse200 = {
  data: RemoteTakeoverRead
  status: 200
}

export type cancelAdminRemoteTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type cancelAdminRemoteTakeoverResponse403 = {
  data: RemoteAccessErrorResponse
  status: 403
}

export type cancelAdminRemoteTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type cancelAdminRemoteTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type cancelAdminRemoteTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type cancelAdminRemoteTakeoverResponseSuccess = (cancelAdminRemoteTakeoverResponse200) & {
  headers: Headers;
};
export type cancelAdminRemoteTakeoverResponseError = (cancelAdminRemoteTakeoverResponse401 | cancelAdminRemoteTakeoverResponse403 | cancelAdminRemoteTakeoverResponse404 | cancelAdminRemoteTakeoverResponse409 | cancelAdminRemoteTakeoverResponse422) & {
  headers: Headers;
};

export type cancelAdminRemoteTakeoverResponse = (cancelAdminRemoteTakeoverResponseSuccess | cancelAdminRemoteTakeoverResponseError)

export const getCancelAdminRemoteTakeoverUrl = (requestId: string,) => {




  return `/api/v1/admin/remote-access/takeover-requests/${requestId}/cancel`
}

/**
 * @summary Cancel Admin Takeover
 */
export const cancelAdminRemoteTakeover = async (requestId: string,
    remoteTakeoverEmpty: RemoteTakeoverEmpty, options?: RequestInit): Promise<cancelAdminRemoteTakeoverResponse> => {

  return orvalClient<cancelAdminRemoteTakeoverResponse>(getCancelAdminRemoteTakeoverUrl(requestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverEmpty)
  }
);}




export const getCancelAdminRemoteTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext> => {

const mutationKey = ['cancelAdminRemoteTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>, {requestId: string;data: RemoteTakeoverEmpty}> = (props) => {
          const {requestId,data} = props ?? {};

          return  cancelAdminRemoteTakeover(requestId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAdminRemoteTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>>
    export type CancelAdminRemoteTakeoverMutationBody = RemoteTakeoverEmpty
    export type CancelAdminRemoteTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Cancel Admin Takeover
 */
export const useCancelAdminRemoteTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAdminRemoteTakeover>>,
        TError,
        {requestId: string;data: RemoteTakeoverEmpty},
        TContext
      > => {
      return useMutation(getCancelAdminRemoteTakeoverMutationOptions(options), queryClient);
    }
    export type launchAdminRemoteTakeoverResponse200 = {
  data: RemoteLaunchIntent
  status: 200
}

export type launchAdminRemoteTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type launchAdminRemoteTakeoverResponse403 = {
  data: RemoteAccessErrorResponse
  status: 403
}

export type launchAdminRemoteTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type launchAdminRemoteTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type launchAdminRemoteTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type launchAdminRemoteTakeoverResponse503 = {
  data: RemoteAccessErrorResponse
  status: 503
}

export type launchAdminRemoteTakeoverResponseSuccess = (launchAdminRemoteTakeoverResponse200) & {
  headers: Headers;
};
export type launchAdminRemoteTakeoverResponseError = (launchAdminRemoteTakeoverResponse401 | launchAdminRemoteTakeoverResponse403 | launchAdminRemoteTakeoverResponse404 | launchAdminRemoteTakeoverResponse409 | launchAdminRemoteTakeoverResponse422 | launchAdminRemoteTakeoverResponse503) & {
  headers: Headers;
};

export type launchAdminRemoteTakeoverResponse = (launchAdminRemoteTakeoverResponseSuccess | launchAdminRemoteTakeoverResponseError)

export const getLaunchAdminRemoteTakeoverUrl = (requestId: string,) => {




  return `/api/v1/admin/remote-access/takeover-requests/${requestId}/launch`
}

/**
 * @summary Launch Admin Takeover
 */
export const launchAdminRemoteTakeover = async (requestId: string,
    remoteTakeoverEmpty: RemoteTakeoverEmpty, options?: RequestInit): Promise<launchAdminRemoteTakeoverResponse> => {

  return orvalClient<launchAdminRemoteTakeoverResponse>(getLaunchAdminRemoteTakeoverUrl(requestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverEmpty)
  }
);}




export const getLaunchAdminRemoteTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof launchAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext> => {

const mutationKey = ['launchAdminRemoteTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchAdminRemoteTakeover>>, {requestId: string;data: RemoteTakeoverEmpty}> = (props) => {
          const {requestId,data} = props ?? {};

          return  launchAdminRemoteTakeover(requestId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchAdminRemoteTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof launchAdminRemoteTakeover>>>
    export type LaunchAdminRemoteTakeoverMutationBody = RemoteTakeoverEmpty
    export type LaunchAdminRemoteTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Launch Admin Takeover
 */
export const useLaunchAdminRemoteTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchAdminRemoteTakeover>>, TError,{requestId: string;data: RemoteTakeoverEmpty}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof launchAdminRemoteTakeover>>,
        TError,
        {requestId: string;data: RemoteTakeoverEmpty},
        TContext
      > => {
      return useMutation(getLaunchAdminRemoteTakeoverMutationOptions(options), queryClient);
    }
    export type listSellerRemoteHostsResponse200 = {
  data: SellerRemoteHostListResponse
  status: 200
}

export type listSellerRemoteHostsResponseSuccess = (listSellerRemoteHostsResponse200) & {
  headers: Headers;
};
;

export type listSellerRemoteHostsResponse = (listSellerRemoteHostsResponseSuccess)

export const getListSellerRemoteHostsUrl = () => {




  return `/api/v1/seller/remote-access/hosts`
}

/**
 * @summary List Seller Hosts
 */
export const listSellerRemoteHosts = async ( options?: RequestInit): Promise<listSellerRemoteHostsResponse> => {

  return orvalClient<listSellerRemoteHostsResponse>(getListSellerRemoteHostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSellerRemoteHostsQueryKey = () => {
    return [
    `/api/v1/seller/remote-access/hosts`
    ] as const;
    }


export const getListSellerRemoteHostsQueryOptions = <TData = Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSellerRemoteHostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSellerRemoteHosts>>> = ({ signal }) => listSellerRemoteHosts({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSellerRemoteHostsQueryResult = NonNullable<Awaited<ReturnType<typeof listSellerRemoteHosts>>>
export type ListSellerRemoteHostsQueryError = unknown


export function useListSellerRemoteHosts<TData = Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSellerRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listSellerRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSellerRemoteHosts<TData = Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSellerRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listSellerRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSellerRemoteHosts<TData = Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Seller Hosts
 */

export function useListSellerRemoteHosts<TData = Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSellerRemoteHostsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createSellerRemoteLaunchResponse200 = {
  data: RemoteLaunchIntent
  status: 200
}

export type createSellerRemoteLaunchResponse409 = {
  data: RemoteLaunchReplayResponse | RemoteAccessErrorResponse
  status: 409
}

export type createSellerRemoteLaunchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createSellerRemoteLaunchResponseSuccess = (createSellerRemoteLaunchResponse200) & {
  headers: Headers;
};
export type createSellerRemoteLaunchResponseError = (createSellerRemoteLaunchResponse409 | createSellerRemoteLaunchResponse422) & {
  headers: Headers;
};

export type createSellerRemoteLaunchResponse = (createSellerRemoteLaunchResponseSuccess | createSellerRemoteLaunchResponseError)

export const getCreateSellerRemoteLaunchUrl = (remoteHostId: string,) => {




  return `/api/v1/seller/remote-access/hosts/${remoteHostId}/launch`
}

/**
 * @summary Launch Seller Host
 */
export const createSellerRemoteLaunch = async (remoteHostId: string, options?: RequestInit): Promise<createSellerRemoteLaunchResponse> => {

  return orvalClient<createSellerRemoteLaunchResponse>(getCreateSellerRemoteLaunchUrl(remoteHostId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateSellerRemoteLaunchMutationOptions = <TError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSellerRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSellerRemoteLaunch>>, TError,{remoteHostId: string}, TContext> => {

const mutationKey = ['createSellerRemoteLaunch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSellerRemoteLaunch>>, {remoteHostId: string}> = (props) => {
          const {remoteHostId} = props ?? {};

          return  createSellerRemoteLaunch(remoteHostId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSellerRemoteLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof createSellerRemoteLaunch>>>

    export type CreateSellerRemoteLaunchMutationError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError

    /**
 * @summary Launch Seller Host
 */
export const useCreateSellerRemoteLaunch = <TError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSellerRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSellerRemoteLaunch>>,
        TError,
        {remoteHostId: string},
        TContext
      > => {
      return useMutation(getCreateSellerRemoteLaunchMutationOptions(options), queryClient);
    }
    export type listSellerRemoteHostMembersResponse200 = {
  data: SellerRemoteMembersRead
  status: 200
}

export type listSellerRemoteHostMembersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listSellerRemoteHostMembersResponseSuccess = (listSellerRemoteHostMembersResponse200) & {
  headers: Headers;
};
export type listSellerRemoteHostMembersResponseError = (listSellerRemoteHostMembersResponse422) & {
  headers: Headers;
};

export type listSellerRemoteHostMembersResponse = (listSellerRemoteHostMembersResponseSuccess | listSellerRemoteHostMembersResponseError)

export const getListSellerRemoteHostMembersUrl = (remoteHostId: string,) => {




  return `/api/v1/seller/remote-access/hosts/${remoteHostId}/members`
}

/**
 * @summary List Seller Host Members
 */
export const listSellerRemoteHostMembers = async (remoteHostId: string, options?: RequestInit): Promise<listSellerRemoteHostMembersResponse> => {

  return orvalClient<listSellerRemoteHostMembersResponse>(getListSellerRemoteHostMembersUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSellerRemoteHostMembersQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/seller/remote-access/hosts/${remoteHostId}/members`
    ] as const;
    }


export const getListSellerRemoteHostMembersQueryOptions = <TData = Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError = HTTPValidationError>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSellerRemoteHostMembersQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>> = ({ signal }) => listSellerRemoteHostMembers(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSellerRemoteHostMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>>
export type ListSellerRemoteHostMembersQueryError = HTTPValidationError


export function useListSellerRemoteHostMembers<TData = Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError = HTTPValidationError>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSellerRemoteHostMembers>>,
          TError,
          Awaited<ReturnType<typeof listSellerRemoteHostMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSellerRemoteHostMembers<TData = Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSellerRemoteHostMembers>>,
          TError,
          Awaited<ReturnType<typeof listSellerRemoteHostMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSellerRemoteHostMembers<TData = Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Seller Host Members
 */

export function useListSellerRemoteHostMembers<TData = Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSellerRemoteHostMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSellerRemoteHostMembersQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type setSellerRemoteHostMembersResponse200 = {
  data: SellerRemoteMembersRead
  status: 200
}

export type setSellerRemoteHostMembersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setSellerRemoteHostMembersResponseSuccess = (setSellerRemoteHostMembersResponse200) & {
  headers: Headers;
};
export type setSellerRemoteHostMembersResponseError = (setSellerRemoteHostMembersResponse422) & {
  headers: Headers;
};

export type setSellerRemoteHostMembersResponse = (setSellerRemoteHostMembersResponseSuccess | setSellerRemoteHostMembersResponseError)

export const getSetSellerRemoteHostMembersUrl = (remoteHostId: string,) => {




  return `/api/v1/seller/remote-access/hosts/${remoteHostId}/members`
}

/**
 * The owner chooses who in the team may use the machine.
 *
 * Takes the authority lock and leaves grant work for the reconciler, like
 * every other assignment write. Owners always keep the machine.
 * @summary Set Seller Host Members
 */
export const setSellerRemoteHostMembers = async (remoteHostId: string,
    sellerRemoteMembersWrite: SellerRemoteMembersWrite, options?: RequestInit): Promise<setSellerRemoteHostMembersResponse> => {

  return orvalClient<setSellerRemoteHostMembersResponse>(getSetSellerRemoteHostMembersUrl(remoteHostId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellerRemoteMembersWrite)
  }
);}




export const getSetSellerRemoteHostMembersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSellerRemoteHostMembers>>, TError,{remoteHostId: string;data: SellerRemoteMembersWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setSellerRemoteHostMembers>>, TError,{remoteHostId: string;data: SellerRemoteMembersWrite}, TContext> => {

const mutationKey = ['setSellerRemoteHostMembers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSellerRemoteHostMembers>>, {remoteHostId: string;data: SellerRemoteMembersWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  setSellerRemoteHostMembers(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSellerRemoteHostMembersMutationResult = NonNullable<Awaited<ReturnType<typeof setSellerRemoteHostMembers>>>
    export type SetSellerRemoteHostMembersMutationBody = SellerRemoteMembersWrite
    export type SetSellerRemoteHostMembersMutationError = HTTPValidationError

    /**
 * @summary Set Seller Host Members
 */
export const useSetSellerRemoteHostMembers = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSellerRemoteHostMembers>>, TError,{remoteHostId: string;data: SellerRemoteMembersWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSellerRemoteHostMembers>>,
        TError,
        {remoteHostId: string;data: SellerRemoteMembersWrite},
        TContext
      > => {
      return useMutation(getSetSellerRemoteHostMembersMutationOptions(options), queryClient);
    }
    export type getSellerRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type getSellerRemoteSessionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getSellerRemoteSessionResponseSuccess = (getSellerRemoteSessionResponse200) & {
  headers: Headers;
};
export type getSellerRemoteSessionResponseError = (getSellerRemoteSessionResponse422) & {
  headers: Headers;
};

export type getSellerRemoteSessionResponse = (getSellerRemoteSessionResponseSuccess | getSellerRemoteSessionResponseError)

export const getGetSellerRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/seller/remote-access/sessions/${sessionId}`
}

/**
 * @summary Get Seller Session
 */
export const getSellerRemoteSession = async (sessionId: string, options?: RequestInit): Promise<getSellerRemoteSessionResponse> => {

  return orvalClient<getSellerRemoteSessionResponse>(getGetSellerRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSellerRemoteSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/seller/remote-access/sessions/${sessionId}`
    ] as const;
    }


export const getGetSellerRemoteSessionQueryOptions = <TData = Awaited<ReturnType<typeof getSellerRemoteSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSellerRemoteSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSellerRemoteSession>>> = ({ signal }) => getSellerRemoteSession(sessionId, { signal });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSellerRemoteSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getSellerRemoteSession>>>
export type GetSellerRemoteSessionQueryError = HTTPValidationError


export function useGetSellerRemoteSession<TData = Awaited<ReturnType<typeof getSellerRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getSellerRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSellerRemoteSession<TData = Awaited<ReturnType<typeof getSellerRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getSellerRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSellerRemoteSession<TData = Awaited<ReturnType<typeof getSellerRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Seller Session
 */

export function useGetSellerRemoteSession<TData = Awaited<ReturnType<typeof getSellerRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSellerRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSellerRemoteSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






